export const generateUtm = (isPartner, recommendationCode, product) => {
  const isUserPartner = isPartner ? 'p' : 'b'
  const utms = {
    NANO: `?utm_source=www&utm_medium=koszyk&utm_campaign=finansowaniefaktury&utm_term=${isUserPartner}-${recommendationCode}&utm_content=c-zaplac&recommendation_code=${recommendationCode}&basketDraftId=XXXXX`,
    SKONTO: `?utm_source=www&utm_medium=koszyk&utm_campaign=finansowaniefaktury&utm_term=${isUserPartner}-${recommendationCode}&utm_content=c-zaplac&recommendation_code=${recommendationCode}&basketDraftId=XXXXX`,
    PURCHASE_FINANCE: `?utm_source=www&utm_medium=koszyk&utm_campaign=finansowaniezakupow&utm_term=${isUserPartner}-${recommendationCode}&utm_content=c-zaplac&recommendation_code=${recommendationCode}&basketDraftId=XXXXX`,
    DEFERRED_PAYMENT: `?utm_source=www&utm_medium=koszyk&utm_campaign=odroczonaplatnosc&utm_term=${isUserPartner}-${recommendationCode}&utm_content=c-zaplac&recommendation_code=${recommendationCode}&basketDraftId=XXXXX`,
  }

  let selectedProduct

  Object.entries(utms).forEach(([key, value]) => {
    if (key !== product) {
      return
    }

    selectedProduct = value
  })

  return selectedProduct
};
